import React from 'react';

class ValidationModal extends React.Component {
    render() {
        const { idValidation, idModalOrigin, idModalDestiny, eventOnclick, message, button1, button2, eventOnclick2, shadow, hideButton2 = false } = this.props;
        return (
            <div className="modal fade" id={idValidation} tabIndex="-1" role="dialog" aria-labelledby="validationModalTitle" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content" style={shadow?{ boxShadow: "rgb(1 1 1 / 30%) 1px 1px 10px"}:{boxShadow: "none"}}>
                        <div className="modal-body">
                            <h4>{message}</h4>
                        </div>
                        <div className="modal-footer">
                            {!hideButton2 && (
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" data-target={idModalOrigin} data-toggle="modal" onClick={eventOnclick2}>{button2 == null ? "Cancelar" : button2}</button>
                            )}
                            <button type="button" className="btn btn-primary" data-dismiss="modal" data-target={idModalDestiny} data-toggle="modal" onClick={eventOnclick}>{button1 == null ? "Aceptar" : button1}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ValidationModal

